(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diwali-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('diwali-countdown-bar')) {
    class DiwaliCountdownBar extends HTMLElement {
      connectedCallback() {
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.endTime = new Date(this.dataset.end).getTime();
        this.hideWhenExpired = this.dataset.hideWhenExpired === 'true';
        this.storageKey = `diwali-bar-dismissed-${this.dataset.end}`;
        this.units = {
          days: this.querySelector('[data-unit="days"]'),
          hours: this.querySelector('[data-unit="hours"]'),
          minutes: this.querySelector('[data-unit="minutes"]'),
          seconds: this.querySelector('[data-unit="seconds"]'),
        };
        this.first = true;

        // Sticky: the Shopify section wrapper must be the sticky element
        this.wrapper = this.closest('.shopify-section');
        if (this.dataset.sticky === 'true') {
          this.wrapper?.classList.add('diwali-bar-sticky-section');
        }

        // Never hide in the theme editor so merchants can always see & edit the bar.
        const inEditor = Boolean(window.Shopify && window.Shopify.designMode);

        if (!inEditor && this.isDismissed()) {
          this.hidden = true;
          return;
        }

        if (Number.isNaN(this.endTime)) {
          if (!inEditor) this.hidden = true;
          return;
        }

        const closeButton = this.querySelector('[data-close]');
        this.onClose = () => this.dismiss();
        closeButton?.addEventListener('click', this.onClose);
        this.closeButton = closeButton;

        this.render();
        this.interval = setInterval(() => this.render(), 1000);
      }

      disconnectedCallback() {
        this.wrapper?.classList.remove('diwali-bar-sticky-section');
        clearInterval(this.interval);
        this.closeButton?.removeEventListener('click', this.onClose);
      }

      isDismissed() {
        try {
          return localStorage.getItem(this.storageKey) === '1';
        } catch (e) {
          return false;
        }
      }

      dismiss() {
        try {
          localStorage.setItem(this.storageKey, '1');
        } catch (e) {}

        clearInterval(this.interval);

        if (this.reduceMotion) {
          this.hidden = true;
          return;
        }

        this.animate(
          { transform: ['translateY(0)', 'translateY(-100%)'], opacity: [1, 0] },
          { duration: 380, easing: 'cubic-bezier(0.55, 0.06, 0.68, 0.19)', fill: 'forwards' }
        ).onfinish = () => {
          this.hidden = true;
        };
      }

      render() {
        const diff = Math.max(0, this.endTime - Date.now());
        const total = Math.floor(diff / 1000);

        const days = Math.floor(total / 86400);
        const hours = Math.floor((total % 86400) / 3600);
        const minutes = Math.floor((total % 3600) / 60);
        const seconds = total % 60;

        this.setDigits(this.units.days, String(days).padStart(days >= 100 ? 3 : 2, '0'));
        this.setDigits(this.units.hours, String(hours).padStart(2, '0'));
        this.setDigits(this.units.minutes, String(minutes).padStart(2, '0'));
        this.setDigits(this.units.seconds, String(seconds).padStart(2, '0'));

        this.first = false;

        if (diff === 0) {
          clearInterval(this.interval);
          const inEditor = Boolean(window.Shopify && window.Shopify.designMode);
          if (this.hideWhenExpired && !inEditor) this.hidden = true;
        }
      }

      setDigits(container, value) {
        if (!container) return;
        let digits = container.querySelectorAll('.diwali-bar__digit');

        if (digits.length !== value.length) {
          container.innerHTML = [...value].map(() => '<span class="diwali-bar__digit">0</span>').join('');
          digits = container.querySelectorAll('.diwali-bar__digit');
          this.first = true;
        }

        [...value].forEach((char, index) => {
          const el = digits[index];
          if (this.first || this.reduceMotion || document.hidden) {
            el.textContent = char;
          } else {
            this.flip(el, char);
          }
        });
      }

      flip(el, value) {
        if (el.textContent === value) return;
        el.getAnimations().forEach((animation) => animation.cancel());

        const out = el.animate(
          [
            { transform: 'rotateX(0deg)', opacity: 1 },
            { transform: 'rotateX(-90deg)', opacity: 0 },
          ],
          { duration: 180, easing: 'cubic-bezier(0.55, 0.06, 0.68, 0.19)', fill: 'forwards' }
        );

        out.onfinish = () => {
          el.textContent = value;
          el.animate(
            [
              { transform: 'rotateX(90deg)', opacity: 0 },
              { transform: 'rotateX(0deg)', opacity: 1 },
            ],
            { duration: 260, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
          );
        };
      }
    }

    customElements.define('diwali-countdown-bar', DiwaliCountdownBar);
  }

  } catch(e) { console.error(e); }
})();
})();
